const map = {
	"./1725791366001(1).jpg": 944,
	"./1725791398998.jpg": 302,
	"./1725791520044.jpg": 69,
	"./1725791895155.jpg": 313,
	"./1725792042994.jpg": 615,
	"./FB_IMG_1725789700664.jpg": 97,
	"./FB_IMG_1725789707189.jpg": 892,
	"./FB_IMG_1725789724013.jpg": 823,
	"./FB_IMG_1725789733437.jpg": 569,
	"./FB_IMG_1725789782331.jpg": 700,
	"./FB_IMG_1725789796215.jpg": 686,
	"./FB_IMG_1725789821143.jpg": 203,
	"./FB_IMG_1725789828054.jpg": 621,
	"./Kitty tmava 1.jpg": 517,
	"./Kitty tyrkys 2.jpg": 279,
	"./kitty modra 1.jpg": 423,
	"./kitty uces 1.jpg": 88,
	"./web1.jpg": 345,
	"./web2.jpg": 750,
	"./web6.jpg": 882,
	"./web7.jpg": 47
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;